import { CallAssistant, CallState, EntityType, ExtensionStatus, ExtensionSubStatus, FileUploaded, Identifier, Media, MediaType, QueueStats } from './model';

interface Legacy {
  OpenDeviceGroupsManager(server: string, extension: string): void
  ShowPresenceDialog(extension: string, server: string, _: null): void
  OpenPresenceSettingsDialog(extension: string, server: string, _: null): void
  OpenExtensionProperties(server: string, extension: string, _: 0): void
  OpenSmartSearch(action: string, server: string, extension: string, status: ExtensionStatus, subStatus: ExtensionSubStatus, callStatus: CallState, supperTrasnfer: boolean, device: String, callid: string, mediaType: MediaType, searchQuery: string, result?: CallbackHandler): void
  CloseSmartSearch(): void
  OpenQueueStatusDialogSingle(extension: string, server: string, queue: string, action: string): void
  OpenQueueForwardDialogSingle(queue: string, queueServer: string, queueDescription: string, action: string): void
  IncomingEvent(message: string): void
  ShowTeamsConfirmDialog(title: string, message: string, result: AlertCallbackHandler, timeout?: number): void
  ShowTeamsAlertDialog(title: string, message: string, icon: AlertIconType, result?: AlertCallbackHandler): void
  ShowTeamsChangeAgentNameDialog(result: AgentNameDialogCallbackHandler): void
  ShowTeamsWorkTimeDialogOverride(): void
  ShowTeamsFileUploadDialog(emailId: string, originalId: string, result: UploadCallbackHandler): void
  ShowEmbededExtensionProperties(div: HTMLDivElement | null, server: string, id: string, onDirty: AlertCallbackHandler, onClose: VoidCallbackHandler): string
  RemoveEmbededExtensionProperties(id: string): void
  SaveEmbededExtensionProperties(): void
  RevertEmbededExtensionProperties(): void
  ShowEmbededExtensionDetails(div: HTMLDivElement | null, server: string, id: string, myId: string): string
  RemoveEmbededExtensionDetails(id: string): void
  TeamsOpenShortCutsWindow(): void
  TeamsUpdateApplicationSetting(applicationSettingId: string, settingType: string, value: string): void
  TeamsOpenCallAssistantDialog(result: CallAssistantCallbackHandler): void
  TeamsCreateNotification(id: string, title: string, body: string, imageSrc: string): void
  TeamsCloseNotification(id: string): void
  TeamsShowInputDialog(title: string, message: string, value: string, button: DialogButtons, input: DialogInputs, result: InputCallbackHandler): void
  TeamsEnabledPhoneDial(on: boolean): void
  TeamsEnabledPhoneBusySetCallback(on: boolean): void
  TeamsShowJoinConferenceDialog(): void
  TeamsOpenForwardReplayDialog(id: string, action: string, mailbox: string, subject: string, from: string, servername: string): void
  MonitorAlert(callback: VoidCallbackHandler): void
  SessionAlert(callback: VoidCallbackHandler): void
  SetupConfig(): void

  ad: {}
  originalJSON: JSON | undefined
  JSON: JSON
}

export type ButtonResponse = 'ok' | 'cancel'

type CallbackHandler = (action: SmartSearchAction, entityType: EntityType, entityId: Identifier | null, number: string, description: string) => void;
type AlertCallbackHandler = (t: string) => void;
type VoidCallbackHandler = () => void;
type AgentNameDialogCallbackHandler = (t: string, v: string) => void;
type InputCallbackHandler = (button: ButtonResponse, vales: string[]) => void;
type UploadCallbackHandler = (id: string, t: FileUploaded | null) => void;
type CallAssistantCallbackHandler = (t: CallAssistant[]) => void;
const legacy: Legacy = window as any

export enum AlertIconType {
  None = 0,
  Info = 1,
  Warning = 2,
  Error = 3,
}

export enum DialogButtons {
  None = -1,
  Ok = 0,
  YesNo = 1,
  OkCancel = 2,
  YesNoCancel = 3,
  OkTimeout = 4,
}

export enum DialogInputs {
  TextFull = 0,
  TextLabel = 1,
}

export function openDeviceGroupsManager({ server, id }: Identifier) {
  legacy.OpenDeviceGroupsManager(server, id)
}

export function showPresenceDialog({ server, id }: Identifier) {
  legacy.ShowPresenceDialog(id, server, null)
}

export function showPresenceSettingsDialog({ server, id }: Identifier) {
  legacy.OpenPresenceSettingsDialog(id, server, null)
}

export function openExtensionProperties({ server, id }: Identifier) {
  legacy.OpenExtensionProperties(server, id, 0)
}

export type SmartSearchAction = 'blind-transfer' | 'supervised-transfer' | 'dial' | 'hold-for' | 'pickup' | 'conference' | 'monitor' | 'intrude' | 'instantmessage'

export function closeSmartSearchDialogTeams() {
  legacy.CloseSmartSearch()
}

export function openSmartSearchDialogTeams(action: SmartSearchAction, { server, id }: Identifier, status: ExtensionStatus, subStatus: ExtensionSubStatus, device: string, supperTrasnfer: boolean, call: Media | null, searchQuery?: string, result?: CallbackHandler) {
  legacy.OpenSmartSearch(action, server, id, status, subStatus, call ? call.status : CallState.None, supperTrasnfer, device, call ? call.id : '', call ? call.mediaType : '', !searchQuery ? '' : searchQuery, result)
}

export function openQueueStatusDialogSingle({ server, id }: Identifier, queue: QueueStats, action: string) {
  legacy.OpenQueueStatusDialogSingle(id, server, queue.id, action)
}

export function openQueueForwardDialogSingle({ server, id }: Identifier, queue: QueueStats, action: string) {
  legacy.OpenQueueForwardDialogSingle(queue.id, queue.server, queue.description, action)
}

export function showConfirmWindow(title: string, message: string, result: AlertCallbackHandler, timeout?: number) {
  legacy.ShowTeamsConfirmDialog(title, message, result, timeout)
}

export function showAlertDialog(title: string, message: string, icon: AlertIconType, result?: AlertCallbackHandler) {
  legacy.ShowTeamsAlertDialog(title, message, icon, result)
}

export function showChangeAgentNameDialog(result: AgentNameDialogCallbackHandler) {
  legacy.ShowTeamsChangeAgentNameDialog(result)
}

export function showTeamsShowInputDialog(title: string, message: string, value: string, button: DialogButtons, input: DialogInputs, result: InputCallbackHandler) {
  legacy.TeamsShowInputDialog(title, message, value, button, input, result)
}

export function showWorkTimeDialogOverride() {
  legacy.ShowTeamsWorkTimeDialogOverride()
}

export function showFileUploadDialog(emailId: string, originalId: string, result: UploadCallbackHandler) {
  legacy.ShowTeamsFileUploadDialog(emailId, originalId, result)
}

export function showEmbededExtensionProperties(div: HTMLDivElement | null, extension: Identifier, onDirty: AlertCallbackHandler, onClose: VoidCallbackHandler): string {
  return legacy.ShowEmbededExtensionProperties(div, extension.server, extension.id, onDirty, onClose)
}

export function removeEmbededExtensionProperties(id: string) {
  legacy.RemoveEmbededExtensionProperties(id)
}

export function saveEmbededExtensionProperties() {
  legacy.SaveEmbededExtensionProperties()
}

export function revertEmbededExtensionProperties() {
  legacy.RevertEmbededExtensionProperties()
}

export function showEmbedExtensionDetails(div: HTMLDivElement | null, extension: Identifier, myId: Identifier): string {
  return legacy.ShowEmbededExtensionDetails(div, extension.server, extension.id, myId.id)
}

export function removeEmbededExtensionDetails(id: string) {
  legacy.RemoveEmbededExtensionDetails(id)
}

export function showTeamsOpenShortCutsWindow() {
  legacy.TeamsOpenShortCutsWindow()
}

export function updateApplicationSetting(applicationSettingId: string, settingType: string, value: string) {
  legacy.TeamsUpdateApplicationSetting(applicationSettingId, settingType, value)
}

export function teamsOpenCallAssistantDialog(result: CallAssistantCallbackHandler) {
  legacy.TeamsOpenCallAssistantDialog(result)
}

export function teamsCreateNotification(id: string, title: string, body: string, imageSrc: string) {
  legacy.TeamsCreateNotification(id, title, body, imageSrc)
}

export function teamsCloseNotification(id: string) {
  legacy.TeamsCloseNotification(id)
}

export function teamsEnabledPhoneDial(on: boolean) {
  legacy.TeamsEnabledPhoneDial(on)
}

export function teamsEnabledPhoneBusySetCallback(on: boolean) {
  legacy.TeamsEnabledPhoneBusySetCallback(on)
}

export function teamsShowJoinConferenceDialog() {
  legacy.TeamsShowJoinConferenceDialog()
}

export function monitorAlert(callback: VoidCallbackHandler) {
  legacy.MonitorAlert(callback)
}

export function sessionAlert(callback: VoidCallbackHandler) {
  legacy.SessionAlert(callback)
}

export function teamsOpenForwardReplayDialog(id: string, action: 'SEND_NEW' | 'SEND_REPLY' | 'SEND_FORWARD', mailbox: string, subject: string, from: string, servername: string) {
  legacy.TeamsOpenForwardReplayDialog(id, action, mailbox, subject, from, servername)
}

export const incomingEvent = legacy.IncomingEvent

export function setConfig(config: {}) {
  legacy.ad = config
  legacy.SetupConfig()
}

export function getOriginalJSON() {
  return legacy.originalJSON || legacy.JSON
}
